<mat-card class="summary-card today">
	<div class="summary-title today">TODAY</div>
	<div class="summary-content">
		<!-- Repeat for each metric -->
		<div class="summary-metric">
			<span class="metric-label">SALES</span>
			<span class="metric-value">{{ todaySalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="todaySalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR %</span>
			<span class="metric-value">{{ todayLabourPerTop }}</span>
			<span class="metric-sub" [innerHTML]="todayLabourPerBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE SALES</span>
			<span class="metric-value">{{ onlineSalesTodayTop |
				currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="onlineSalesTodayBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE CUSTOMER ORDERS</span>
			<span class="metric-value">{{ onlineCustomerOrdersTodayTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="onlineCustomerOrdersTodayBottom"></span>
		</div>
		@if (this.shopType!="DT") {
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU SALES</span>
			<span class="metric-value">{{ driveThruSalesTodayTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="driveThruSalesTodayBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU ORDERS</span>
			<span class="metric-value">{{ driveThruOrdersTodayTop }}</span>
			<span class="metric-sub" [innerHTML]="driveThruOrdersTodayBottom"></span>
		</div>
		}
		<div class="summary-metric">
			<span class="metric-label">TARGET</span>
			<span class="metric-value">{{ todayTargetTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="todayTargetBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR HOURS</span>
			<span class="metric-value">{{ todayLabourHoursTop }}</span>
			<span class="metric-sub" [innerHTML]="todayLabourHoursBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">CUSTOMER ORDERS</span>
			<span class="metric-value">{{ todayCustomerOrdersTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="todayCustomerOrdersBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR COST</span>
			<span class="metric-value">{{ todayLabourCostTop | currency:'USD':'symbol':'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="todayLabourCostBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ITEM SOLD</span>
			<span class="metric-value">{{ todayItemsSoldTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="todayItemsSoldBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES / LABOUR HOUR</span>
			<span class="metric-value">{{ todaySalesByLabourHourTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="todaySalesByLabourHourBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ todaySalesValueByItemTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="todaySalesValueByItemBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">STAFF WORKING NOW</span>
			<span class="metric-value">{{ todayStaffWorkingNowTop }}</span>
			<span class="metric-sub">{{ todayStaffWorkingNowBottom }}</span>
		</div>
	</div>
</mat-card>